module.exports = {
  name: 'discovery',
  remotes: [],
  additionalShared: [
    '@angular/animations',
    '@angular/forms',
  ],
};
